import { render, staticRenderFns } from "./PendingAttendancePrompt.vue?vue&type=template&id=66550bd2&scoped=true"
import script from "./PendingAttendancePrompt.vue?vue&type=script&lang=js"
export * from "./PendingAttendancePrompt.vue?vue&type=script&lang=js"
import style0 from "./PendingAttendancePrompt.vue?vue&type=style&index=0&id=66550bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66550bd2",
  null
  
)

export default component.exports